import $ from 'jquery';

const IframeLoader = () => {
    $(document).ready(function () {
        const $recordingsTab = $('a[href="#recordings"]');
        const $iframeElements = $('.recordings__iframe iframe.lazy-iframe');
        
        function loadIframes() {
            $iframeElements.each(function() {
                const $iframe = $(this);
                if (!$iframe.attr('src')) {
                    $iframe.attr('src', $iframe.data('src')); 
                }
            });
        }

        if (window.location.hash === "#recordings") {
            loadIframes();
        }

        if ($recordingsTab.length && $iframeElements.length) {
            $recordingsTab.on('click', function() {
                loadIframes();
            });
        }
    });
};

export default IframeLoader;
